import React, { useState, useContext, useEffect, useRef } from "react";
import { useHistory } from "react-router-dom";

import { i18n } from "../../translate/i18n";
import PermissionModal from "../PermissionModal";
import { AuthContext } from "../../context/Auth/AuthContext";
import apiV2 from "../../services/apiV2";
import toastError from "../../errors/toastError";
import ConfirmationModal from "../ConfirmationModal";
import TransferTicketModal from "../TransferTicketModal";
import AcceptTicketWithouSelectQueue from "../AcceptTicketWithoutQueueModal";

const options = [
	{ text: i18n.t("messagesList.header.buttons.solverWithoutGoodbye"),
		value: "solveWithoutGoodbye" },
	{ text: i18n.t("messagesList.header.buttons.return"),
		value: "return" },
	{ text: i18n.t("ticketOptionsMenu.transfer"),
		value: "transfer" },
	{ text: i18n.t("ticketOptionsMenu.delete"),
		value: "delete" },
];

export default function TicketBulkActionsButtons({
	bulkSelected = [],
	setBulkSelection,
	ticketStatus,
	onTicketUpdated = null,
	reload,
}) {
	const [open, setOpen] = React.useState(false);
	const [permissionOpen, setPermissionOpen] = useState(false);
	const [confirmationOpen, setConfirmationOpen] = useState(false);
	const [loading, setLoading] = useState(false);
	const [transferTicketModalOpen, setTransferTicketModalOpen] = useState(false);
	const [acceptTicketWithouSelectQueueOpen, setAcceptTicketWithouSelectQueueOpen] = useState(false);
	const [ticketsSemSetor, setTicketsSemSetor] = useState([]);
	const history = useHistory();

	const { user } = useContext(AuthContext);

	const handleToggle = () => {
		setOpen((prevOpen) => !prevOpen);
	};

	async function handleBulkUpdateTicketStatus(
		status,
		userId,
		ticktIdList,
		sendMessage
	) {
		if (loading || ticktIdList.length === 0) return;

		setLoading(true);

		try {
			const { data } = await apiV2.put('/bulktickets', {
				TicketIDs: ticktIdList,
				status,
				userId: userId || null,
				sendMessage,
			});

			data.forEach((ticketid) => {
				onTicketUpdated?.(data);
			});
			setBulkSelection(false);
		} catch (err) {
			toastError(err);
		} finally {
			if(document.querySelectorAll('input[type="checkbox"][name="bulkSelected"]').length === 0){
				reload();
			}

			setLoading(false);
		}
	}

	async function GetTicketsSemSetorSelecionado() {
		try {
			const { data } = await apiV2.get('/bulktickets/unqueued', {
				params: { ticketIds: bulkSelected.join(',') },
			});
			return data.map(ticket => ticket.id)
		} catch (err) {
			toastError(err);
		}
	}
	async function AceitaTicket() {
		const ticketSemSetor = await GetTicketsSemSetorSelecionado();

		if (ticketSemSetor.length > 0) {
			setTicketsSemSetor(ticketSemSetor)
			setAcceptTicketWithouSelectQueueOpen(true);

			const ticketsComSetor = bulkSelected.filter(ticketid =>
				!ticketSemSetor.includes(ticketid)
			);

			handleBulkUpdateTicketStatus("open", user.id, ticketsComSetor, false);
		} else {
			handleBulkUpdateTicketStatus("open", user.id, bulkSelected, false);
		}
		setLoading(false);

	}

	const handleMenuItemClick = (value) => {
		if(bulkSelected.length <= 0){
			toastError("Select at least one option.")
			return
		}

		setLoading(true);
		switch (value) {
			case "open":
				handleBulkUpdateTicketStatus("open", user.id, bulkSelected, false);
				break
			case "acept":

				AceitaTicket();
				break
			case "resolve":
				handleBulkUpdateTicketStatus("closed", user.id, bulkSelected, true);
				break;
			case "solveWithoutGoodbye":
				handleBulkUpdateTicketStatus("closed", user?.id, bulkSelected, false);
				break;
			case "return":
				handleBulkUpdateTicketStatus("pending", null, bulkSelected, false);
				break;
			case "delete":
				user.profile === "admin"
					? setConfirmationOpen(true)
					: setPermissionOpen(true);
				setLoading(false);
				break;
			case "transfer":
				setTransferTicketModalOpen(true);
				setLoading(false);
				break;
			default:
				break;
		}
		setOpen(false);
	};

	const handleDeleteTicket = async () => {
		try {
			await apiV2.delete('/bulktickets',{
				data: { ticketIDs: bulkSelected }
			});
			history.push("/tickets");
			setLoading(false);
			setBulkSelection(false);
		} catch (err) {
			toastError(err);
		}
	};

	return (
		<>
			<PermissionModal open={permissionOpen} onClose={setPermissionOpen} />

			<div
				className="tailwick-ticket-actions relative"
			>
				<div className="tailwick-ticket-actions__split">
					<button
						type="button"
						className="tailwick-ticket-actions__main btn btn-sm btn-primary"
						disabled={loading}
						onClick={() => handleMenuItemClick(ticketStatus === "open" ? "resolve" : ticketStatus === "peding" ? "open" : "acept" )}
					>
						{loading ? (
							<span
								className="size-4 animate-spin rounded-full border-2 border-white border-t-transparent"
								aria-hidden
							/>
						) : (
							ticketStatus === "open" ? i18n.t("messagesList.header.buttons.resolve")
								: ticketStatus === "pending"
									? i18n.t("messagesList.header.buttons.accept")
									: i18n.t("messagesList.header.buttons.reopen")
						)}
					</button>
					{ticketStatus === "open" &&
						<button
							type="button"
							className="tailwick-ticket-actions__toggle btn btn-sm btn-primary"
							disabled={loading}
							aria-expanded={open}
							aria-haspopup="menu"
							onClick={handleToggle}
						>
							<svg
								className={`size-4 transition-transform${open ? " rotate-180" : ""}`}
								viewBox="0 0 24 24"
								fill="none"
								stroke="currentColor"
								strokeWidth="2"
								aria-hidden
							>
								<polyline points="6 9 12 15 18 9" />
							</svg>
						</button>
						}
				</div>
				{open && (
					<div
						className="tailwick-ticket-actions__menu"
						role="menu"
						id="tailwick-ticket-actions-menu"
					>
						{options.map((option) => (
							<button
								key={option.value}
								type="button"
								role="menuitem"
								className="tailwick-ticket-actions__menu-item"
								onClick={() => handleMenuItemClick(option.value)}
							>
								{option.text}
							</button>
						))}
					</div>
				)}
			</div>
			<ConfirmationModal
				title={`${i18n.t("ticketOptionsMenu.confirmationbukuModal.title")}?`}
				open={confirmationOpen}
				onClose={setConfirmationOpen}
				onConfirm={handleDeleteTicket}
			>
				{i18n.t("ticketOptionsMenu.confirmationbukuModal.message")}
			</ConfirmationModal>
			<TransferTicketModal
				modalOpen={transferTicketModalOpen}
				onClose={() => {setTransferTicketModalOpen(false);}}
				ticketid={bulkSelected}
				afterTransfer={(()=>{
					setBulkSelection(false)
					setTransferTicketModalOpen(false);
				})}
			/>
			<AcceptTicketWithouSelectQueue
				modalOpen={acceptTicketWithouSelectQueueOpen}
				onClose={() => {
					setBulkSelection(false);
					setAcceptTicketWithouSelectQueueOpen(false);
				}}
				ticketId={ticketsSemSetor}
			/>
		</>
	);
}
